import { useMemo, useState } from 'react'
import { useTranslation } from 'libs/i18n'
import {
	BookingEngineTabs,
	CardHeader,
	CardWrapper,
	EmptyTable,
	Header,
	SearchInput
} from 'shared/components'
import { matchesSearch } from 'utils/matchesSearch'
import { useWeekday } from 'features/openingHours/hooks/useWeekday'
import { useContextMenuOptions } from './hooks/useContextMenuOptions'
import { useFetchOpeningHours } from './queries/useFetchOpeningHours'
import { TableSection } from './organisms/TableSection'

const OpeningHoursPage = () => {
	const { t } = useTranslation()
	const [search, setSearch] = useState('')
	const getWeekday = useWeekday()
	const { openingHours, isLoadingOpeningHours } = useFetchOpeningHours()
	const menuOptions = useContextMenuOptions()
	const allOpeningHours = openingHours?.data ?? []
	const results = useMemo(
		() =>
			(openingHours?.data ?? []).filter((openingHour) =>
				matchesSearch(search, [
					openingHour.date,
					getWeekday(openingHour.date),
					openingHour.is_holiday,
					openingHour.reason
				])
			),
		[openingHours, search, getWeekday]
	)

	const renderContent = () => {
		if (isLoadingOpeningHours) return <EmptyTable isLoading />
		if (!results.length)
			return <EmptyTable text={search ? t('No results') : t('No opening hours yet')} />

		return (
			<TableSection results={results} total={allOpeningHours.length} menuOptions={menuOptions} />
		)
	}

	return (
		<>
			<Header title={t('Booking engine')} tabs={<BookingEngineTabs />} />
			<div className="px-5 lg:flex lg:max-h-[calc(100vh-113.5px-4rem)] lg:flex-col lg:px-0">
				<CardWrapper className="lg:flex lg:min-h-0 lg:flex-1 lg:flex-col">
					<CardHeader
						title={t('Opening hours')}
						description={t('Controls which days are open in the online booking widget.')}>
						<SearchInput
							variant="filled"
							className="sm:w-64"
							label={t('Search dates')}
							placeholder={t('Search dates')}
							onChange={(event) => setSearch(event.target.value)}
						/>
					</CardHeader>
					{renderContent()}
				</CardWrapper>
			</div>
		</>
	)
}

export default OpeningHoursPage
